import { ResponsiveTable } from '@/components/Table/ResponsiveTable/ResponsiveTable';
import { AutomobileOption } from '@/reports/types/vehicles';
import { Button, Text, Modal } from '@/theme/index';
import { capitalizeString } from '@/utils/capitalizeString';

export interface VehicleOptionsModalProps {
  open: boolean;
  handleClose: () => unknown;
  currentOption: AutomobileOption;
}

export const VehicleOptionsModal = ({
  open,
  handleClose,
  currentOption,
}: VehicleOptionsModalProps) => {
  const equipmentsData = currentOption?.equipment?.map((equipment) => {
    const value = parseInt(equipment.value || '');
    return [
      equipment.group || '',
      equipment.name || '',
      equipment.attribute || '',
      equipment.location || '',
      Number.isNaN(value) ? equipment.value || '' : `$${value}`,
    ].map((cell) => {
      return (
        <Text variant="body2" sx={{ p: 1 }}>
          {cell}
        </Text>
      );
    });
  });
  const equipmentsDataIsEmpty = equipmentsData.every((row) =>
    row.every((cell) => typeof cell === 'string' && cell === '')
  );
  const installedText = currentOption.installed ? 'Installed' : 'Available';

  const optionTypeText =
    currentOption.type === 'O'
      ? 'option'
      : currentOption.type === 'P'
      ? 'package'
      : '';

  const header = ['Category', 'Name', 'Attribute', 'Location', 'Value'].map(
    (cell) => {
      return (
        <Text variant="h5" sx={{ p: 1, m: 0 }}>
          {cell}
        </Text>
      );
    }
  );

  return (
    <Modal
      open={open}
      hideBackdrop
      hasCloseIcon={false}
      disableScrollLock
      sx={{
        '.MuiDialog-paper': {
          width: '600px',
        },
      }}
    >
      <Text variant="h3">
        {installedText} {optionTypeText}: {capitalizeString(currentOption.name)}
      </Text>
      {equipmentsDataIsEmpty ? (
        <Text>
          There is no data for this {optionTypeText} available. Please check
          later.
        </Text>
      ) : (
        <>
          <Text>
            Below are the details on the {capitalizeString(currentOption.name)}{' '}
            {optionTypeText} for this vehicle
          </Text>
          {Boolean(equipmentsData.length) && (
            <ResponsiveTable
              tableData={equipmentsData}
              headers={header}
              sectionId="vehicle-specs-modal-data"
            />
          )}
        </>
      )}
      <Button
        disableRipple
        variant="contained"
        color="success"
        sx={{ display: 'flex', m: '2rem auto 0' }}
        onClick={handleClose}
      >
        Return to vehicle search
      </Button>
    </Modal>
  );
};
